import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import threadsAPI from '../api/threads';
import './ShareChat.css';

const ShareChat = () => {
  const { thread_id } = useParams();
  const navigate = useNavigate();
  const { userId, isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showOwnerPopup, setShowOwnerPopup] = useState(false);

  // Generate a random hash ID for the session
  const generateHashId = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  };

  useEffect(() => {
    const handleRedirect = async () => {
      try {
        setIsLoading(true);
        
        // Check if user is authenticated
        if (isAuthenticated && userId) {
          // Fetch thread to check ownership
          try {
            const threadData = await threadsAPI.getThreadById(thread_id);
            
            if (threadData && threadData.owner_id === userId) {
              // User is the owner, redirect to ThreadView with popup
              setShowOwnerPopup(true);
              setTimeout(() => {
                navigate(`/thread/${thread_id}`, { replace: true });
              }, 2000);
              return;
            }
          } catch (threadErr) {
            console.error('Failed to fetch thread:', threadErr);
            // Continue with normal redirect if thread fetch fails
          }
        }
        
        // Generate random hash ID and redirect to ChatSession
        const hashId = generateHashId();
        navigate(`/chat/session/${hashId}/thread/${thread_id}`, { replace: true });
        
      } catch (err) {
        console.error('Failed to handle share redirect:', err);
        setError('Failed to load chat session');
      } finally {
        setIsLoading(false);
      }
    };

    if (thread_id) {
      handleRedirect();
    }
  }, [thread_id, userId, isAuthenticated, navigate]);

  if (isLoading) {
    return (
      <div className="share-chat-loading">
        <div className="loading-spinner"></div>
        <p>Redirecting to chat session...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="share-chat-error">
        <h3>Error</h3>
        <p>{error}</p>
        <button 
          className="btn btn-primary"
          onClick={() => navigate('/dashboard')}
        >
          Go to Dashboard
        </button>
      </div>
    );
  }

  if (showOwnerPopup) {
    return (
      <div className="share-chat-owner-popup">
        <div className="owner-popup-content">
          <div className="owner-popup-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zM10 17l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
            </svg>
          </div>
          <h2>This is your thread!</h2>
          <p>Redirecting you to the thread management page...</p>
          <div className="loading-spinner"></div>
        </div>
      </div>
    );
  }

  return null;
};

export default ShareChat;
